/*
 *  			'License for ONE AXA SOFTWARE - Inner Source'
 * 					L O A S - I S
 * 
 * The following License aims to be applied between the AXA Companies, according to the following definition:
 * "AXA Companies" means AXA, Société Anonyme with a “AXA Companies ” Board of Directors having its principal offices at 25, avenue Matignon, 75008 Paris, registered on the Commercial Registry of Paris under the number 572 093 920; and (i) any other company controlled by, or controlling AXA, with a company being considered as controlling another: (a) when it holds directly or indirectly a portion of the capital according to it the majority of the voting rights in general meetings of shareholders of this company; (b) when it holds solely the majority of the voting rights in this company by virtue of an agreement concluded with other partners or shareholders and which is not contrary to the interest of the company; (c) when it determines de facto, by voting rights which it holds, the decisions in the general meetings of shareholders of this company; (d) in any event, when it holds, directly or indirectly, a portion of voting rights greater than 40% and when no other partner or shareholder holds directly or indirectly a portion which is greater than its own; (ii) any economic interest group in which AXA and/or one or more other Companies of the AXA Group participates for at least 50% in operating costs; (iii) in the cases where the law applicable to a company limits voting rights or control (such as defined here in above), this company will be deemed to be a company of the AXA Group, if the voting rights in 2 Binding Corporate Rules – AXA Group – version 2013 general shareholders’ meetings or the control held by a Company of the AXA Group reaches the maximum amount fixed by said applicable law; and (iv) all AXA Companies constitute the “AXA Group” (hereafter "One AXA").  (Binding Corporate Rules - AXA Group - version 2019).
 * 
 * Software credits: 
 * 	Creator: AXA GO GETD
 * 	Main contributors: AXA GO GETD
 * 
 * Permission is hereby granted, free of charge, to any person or entity within One AXA obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software within One AXA, including the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * 
 * The above credit notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * Any improvement or modification of the Software shall be made available to the whole One AXA, under the terms of this License.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import css from 'styled-jsx/css';
import { colors, theme, sizes } from '@styles/theme';

export default css.global`
  .black {
    color: ${colors.secondary};
  }
  .white {
    color: ${colors.white};
  }
  .grey {
    color: ${colors.darkGrey};
  }
  .bold {
    font-weight: 600;
  }
  .bolder {
    font-weight: 700;
  }
  .no-border {
    border: none;
  }
  .no-margin {
    margin: 0;
  }
  .no-padding {
    padding: 0;
  }
  .no-margin-padding {
    margin: 0;
    padding: 0;
  }
  .margin-right-common {
    margin-right: ${sizes.common};
  }
  .margin-bottom-small {
    margin-bottom: ${sizes.centi};
  }
  .visible {
    visibility: visible;
  }
  .invisible {
    visibility: hidden;
  }
  .hidden {
    display: none;
  }
  .block {
    display: block;
  }
  .inline-block {
    display: inline-block;
  }
  .inline {
    display: inline;
  }
  .flex {
    display: flex;
  }
  .row {
    flex-direction: row;
  }
  .row-reverse {
    flex-direction: row-reverse;
  }
  .column {
    flex-direction: column;
  }
  .column-reverse {
    flex-direction: column-reverse;
  }
  .space-between {
    justify-content: space-between;
  }
  .align-middle {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .inline-flex {
    display: inline-flex;
  }
  /* Box model sizes contains borders and paddings */
  .box-border {
    box-sizing: border-box;
  }
  /* Box model sizes no contains borders and paddings just content */
  .box-content {
    box-sizing: content-box;
  }
  .shadow-lighter {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
  .text-left {
    text-align: right;
  }
  .text-right {
    text-align: right;
  }
  .text-center {
    text-align: center;
  }
  .italic {
    font-style: italic;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .lowercase {
    text-transform: lowercase;
  }
  .capitalize {
    text-transform: capitalize;
  }
  .capitalize-first::first-letter {
    text-transform: capitalize;
  }
  .no-decoration {
    text-decoration: none;
  }
  .underline {
    text-decoration: underline;
  }
  .no-bullets {
    list-style: none;
  }
  .no-selectable {
    user-select: none;
  }
  .accent-positive {
    color: ${theme.colors.accentPositive};
  }
  .accent-negative {
    color: ${theme.colors.accentNegative};
  }
  .accent-informative {
    color: ${theme.colors.accentInformative};
  }
  .b-accent-positive {
    background: ${theme.colors.accentPositive};
  }
  .b-accent-negative {
    background: ${theme.colors.accentNegative};
  }
  .b-accent-informative {
    background: ${theme.colors.accentInformative};
  }

  /* Resize an eleme ;nt's content to stay contained within its container */
  .object-contain {
    object-fit: contain;
  }
  /* Resize an element's content to cover its container */
  .object-cover {
    object-fit: cover;
  }
  /* Stretch an element's content to fit its container */
  .object-fill {
    object-fit: fill;
  }
  /* Display an element's content at its original size ignoring the container size */
  .object-none {
    object-fit: none;
  }
  /* Display an element's content at its original size but scale it down to fit its container if necessary using */
  .object-scale-down {
    object-fit: scale-down;
  }
  /* object-position used in conjunction with object-fit property and defines how an element such as a video or image is 
  positioned with X/Y coordinates inside its content-box */
  /* default value: image is centered -->object-position: 50% 50%; */
  .object-bottom {
    object-position: bottom;
  }
  .object-center {
    object-position: center;
  }
  .object-left {
    object-position: left;
  }
  .object-left-bottom {
    object-position: left bottom;
  }
  .object-left-top {
    object-position: left top;
  }
  .object-right {
    object-position: right;
  }
  .object-right-bottom {
    object-position: right bottom;
  }
  .object-right-top {
    object-position: right top;
  }
  .object-top {
    object-position: top;
  }

  /* Overflow: how an element handles content that is too large for the container. */
  /* add scrollbars when content overflows */
  .overflow-auto {
    overflow: auto;
  }
  /* clip any content within an element that overflows the bounds of that element. */
  .overflow-hidden {
    overflow: hidden;
  }
  /* prevent content within an element from being clipped */
  .overflow-visible {
    overflow: visible;
  }
  /* Always add scrolls */
  .overflow-scroll {
    overflow: scroll;
  }
  /* allow horizontal scrolling if needed. */
  .overflow-x-auto {
    overflow-x: auto;
  }
  /* allow horizontal scrolling if needed. */
  .overflow-y-auto {
    overflow-y: auto;
  }
  .overflow-x-hidden {
    overflow-x: hidden;
  }
  .overflow-y-hidden {
    overflow-y: hidden;
  }
  .overflow-x-visible {
    overflow-x: visible;
  }
  .overflow-y-visible {
    overflow-y: visible;
  }
  /* allow horizontal scrolling and always show scrollbars unless always-visible scrollbars are disabled by the operating system */
  .overflow-x-scroll {
    overflow-x: scroll;
  }
  .overflow-y-scroll {
    overflow-y: scroll;
  }
  /* Position */
  .static {
    position: static;
  }
  .fixed {
    position: fixed;
  }
  /* Offsets are calculated relative to the nearest parent that has a position other than static */
  .absolute {
    position: absolute;
  }
  .relative {
    position: relative;
  }
  .sticky {
    position: sticky;
  }
  .inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .inset-y-0 {
    top: 0;
    bottom: 0;
  }
  .inset-x-0 {
    right: 0;
    left: 0;
  }
  .top-0 {
    top: 0;
  }
  .right-0 {
    right: 0;
  }
  .bottom-0 {
    bottom: 0;
  }
  .left-0 {
    left: 0;
  }
  .inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }
  .inset-y-auto {
    top: auto;
    bottom: auto;
  }
  .inset-x-auto {
    left: auto;
    right: auto;
  }
  .top-auto {
    top: auto;
  }
  .bottom-auto {
    bottom: auto;
  }
  .left-auto {
    left: auto;
  }
  .right-auto {
    right: auto;
  }
  .rotate-180deg {
    transform: rotate(180deg);
  }
  .rotate-90deg {
    transform: rotate(90deg);
  }
  .rotate-n90deg {
    transform: rotate(-90deg);
  }
  .z-0 {
    z-index: 0;
  }
  .z-10 {
    z-index: 10;
  }
  .z-20 {
    z-index: 20;
  }
  .z-30 {
    z-index: 30;
  }
  .z-40 {
    z-index: 40;
  }
  .z-50 {
    z-index: 50;
  }
  .z-1050 {
    z-index: 1050;
  }
  .z-auto {
    z-index: auto;
  }
`;
